module.exports = __webpack_public_path__ + "public/img/08.6608b486.jpg";